import React from "react";
import ActionButton from "../buttons/ActionButton";
import { useNavigate } from "react-router-dom";

interface NoteSoldFormProps {
  props?: any;
}

const NoteSoldForm = ({ props }: NoteSoldFormProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-col columns-1 items-center justify-center">
        <div className="mb-4">
          <p className="text-center">
            This lender opportunity got scooped up fast! If you’re interested in
            investing in a note, don’t wait too long. Chances are someone else
            is interested in targeting strong returns on it too. If you’re
            ready, go to Available Notes section to see which deal could be your
            next to target passive income
          </p>
        </div>
        <div className="" onClick={() => navigate("/?status=Available")}>
          <ActionButton onClick={() => {}} label="AVAILABLE MORTGAGE NOTES" />
        </div>
      </div>
    </>
  );
};

export default NoteSoldForm;
